import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import '../newsite/newsite.css';
import '../newsite/onboard.css';
import { SiteEffects, MinimalHeader, usePageMeta } from '../newsite/SiteChrome';
import { OnboardChat } from '../newsite/OnboardChat';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OnboardShared() {
  const { token } = useParams();
  usePageMeta('Add Your Perspective — X Scale', 'A teammate shared a project intake with you. Review the conversation and add your input.');

  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [session, setSession] = useState(null);
  const [teammate, setTeammate] = useState('');
  const [stage, setStage] = useState('name'); // name | chat | done

  useEffect(() => {
    fetch(`${API}/onboard/shared/${token}`)
      .then((r) => { if (!r.ok) throw new Error(); return r.json(); })
      .then((data) => {
        setSession(data);
        if (data.status === 'submitted') setStage('done');
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="xscale-site onboard-page" data-testid="onboard-shared-page">
      <SiteEffects />
      <MinimalHeader />

      <div className="onboard-shell">
        {loading && <div className="onboard-intro"><p className="onboard-sub">Loading…</p></div>}

        {!loading && notFound && (
          <div className="onboard-intro" data-testid="shared-not-found">
            <h1>Link not found.</h1>
            <p className="onboard-sub">This share link is invalid or has expired.</p>
          </div>
        )}

        {!loading && session && stage === 'name' && (
          <div className="onboard-intro reveal is-visible" data-testid="shared-intro">
            <div className="eyebrow"><span /> TEAM INPUT REQUESTED</div>
            <h1>Add your perspective.</h1>
            <p className="onboard-sub">
              {session.contact.name} ({session.contact.company}) shared their project intake with you.
              Review the conversation and add anything the team should know before we scope it.
            </p>
            <form
              className="onboard-form"
              onSubmit={(e) => { e.preventDefault(); if (teammate.trim()) setStage('chat'); }}
              data-testid="teammate-name-form"
            >
              <div className="onboard-field">
                <label htmlFor="tm-name">Your name</label>
                <input id="tm-name" value={teammate} placeholder="Alex Johnson"
                  onChange={(e) => setTeammate(e.target.value)} data-testid="teammate-name-input" />
              </div>
              <button type="submit" className="button button-primary" disabled={!teammate.trim()} data-testid="join-conversation-btn">
                View conversation
              </button>
            </form>
          </div>
        )}

        {!loading && session && stage === 'chat' && (
          <OnboardChat
            shareToken={token}
            speakerName={teammate.trim()}
            initialMessages={session.messages}
            initialCompleted={session.completed}
            allowShare={false}
            onSubmitted={() => setStage('done')}
          />
        )}

        {stage === 'done' && (
          <div className="onboard-done" data-testid="shared-done">
            <div className="done-orb"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M20 6L9 17l-5-5" /></svg></div>
            <h2>Brief submitted.</h2>
            <p>This project brief has been submitted to the X Scale team. We&rsquo;ll be in touch shortly.</p>
            <a className="button button-secondary" href="/" data-testid="shared-back-home-btn">Back to X Scale</a>
          </div>
        )}
      </div>
    </div>
  );
}
